var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { attrs: { id: "FormMultipleSelection" } }, [
    _c(
      "div",
      {
        class: "form-multiple-selection multiple-selection-align-" + _vm.align,
      },
      [
        _c("input", {
          staticClass: "form-multiple-selection-title",
          attrs: { type: "text" },
          domProps: { value: "" + _vm.fieldLabel },
          on: { input: _vm.debouncedUpdateField },
        }),
        _vm._v(" "),
        _c(
          "div",
          [
            _vm._l(_vm.multipleOptions, function (option, index) {
              return _c(
                "div",
                { key: index, staticClass: "form-multiple-selection-option" },
                [
                  _c("input", {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value: _vm.selectedMultipleOptions,
                        expression: "selectedMultipleOptions",
                      },
                    ],
                    attrs: { type: "checkbox", id: "multiple-option-" + index },
                    domProps: {
                      value: option,
                      checked: Array.isArray(_vm.selectedMultipleOptions)
                        ? _vm._i(_vm.selectedMultipleOptions, option) > -1
                        : _vm.selectedMultipleOptions,
                    },
                    on: {
                      input: _vm.debouncedUpdateField,
                      change: function ($event) {
                        var $$a = _vm.selectedMultipleOptions,
                          $$el = $event.target,
                          $$c = $$el.checked ? true : false
                        if (Array.isArray($$a)) {
                          var $$v = option,
                            $$i = _vm._i($$a, $$v)
                          if ($$el.checked) {
                            $$i < 0 &&
                              (_vm.selectedMultipleOptions = $$a.concat([$$v]))
                          } else {
                            $$i > -1 &&
                              (_vm.selectedMultipleOptions = $$a
                                .slice(0, $$i)
                                .concat($$a.slice($$i + 1)))
                          }
                        } else {
                          _vm.selectedMultipleOptions = $$c
                        }
                      },
                    },
                  }),
                  _vm._v(" "),
                  _c("label", { attrs: { for: "multiple-option-" + index } }, [
                    _vm._v(_vm._s(option)),
                  ]),
                  _vm._v(" "),
                  _c(
                    "button",
                    {
                      staticClass: "remove-option",
                      on: {
                        click: function ($event) {
                          return _vm.removeMultipleOption(index)
                        },
                      },
                    },
                    [_vm._v("X")]
                  ),
                ]
              )
            }),
            _vm._v(" "),
            _c("input", {
              directives: [
                {
                  name: "model",
                  rawName: "v-model",
                  value: _vm.newMultipleOption,
                  expression: "newMultipleOption",
                },
              ],
              staticClass: "form-multiple-selection-new-option",
              attrs: { type: "text", placeholder: "Bir seçenek yazın" },
              domProps: { value: _vm.newMultipleOption },
              on: {
                input: [
                  function ($event) {
                    if ($event.target.composing) {
                      return
                    }
                    _vm.newMultipleOption = $event.target.value
                  },
                  _vm.debouncedUpdateField,
                ],
              },
            }),
            _vm._v(" "),
            _c(
              "button",
              {
                staticClass: "form-multiple-selection-add-button",
                on: { click: _vm.addMultipleOption },
              },
              [_vm._v("Seçenek Ekle\n            ")]
            ),
            _vm._v(" "),
            _c(
              "button",
              {
                staticClass: "form-multiple-selection-add-other-button",
                on: { click: _vm.addMultipleOtherOption },
              },
              [_vm._v('\n                "Diğer" seçeneği ekle\n            ')]
            ),
          ],
          2
        ),
      ]
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }